import { render, staticRenderFns } from "./GearChangesTabs.vue?vue&type=template&id=f856736e"
import script from "./GearChangesTabs.vue?vue&type=script&lang=js"
export * from "./GearChangesTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports